module.exports = __webpack_public_path__ + "img/snorkeling-9.1112062b.jpeg";